export class Position {
    constructor(
        public Longitude: number,
        public Latitude: number,
        public Altitude: number = 0
    ) { }
}